import { PRODUCT_TYPE } from "../constants/commonConstants";

export const isSaccLoan = (loanAmount, requestedProductType) => {
    return requestedProductType !== PRODUCT_TYPE.LINE_OF_CREDIT && loanAmount <= 2000;
}